module.exports = __webpack_public_path__ + "img/cmmc-badge.3691cea4.png";